import $ from 'jquery';
import Highcharts from 'highcharts/es-modules/masters/highcharts.src';
import 'highcharts/es-modules/masters/modules/accessibility.src';
import 'highcharts/es-modules/masters/modules/exporting.src';
import 'highcharts/es-modules/masters/modules/offline-exporting.src';
import '@/lib/highcharts_checkbox_position';

Highcharts.setOptions({
  credits: {
    enabled: true
  },
  lang: {
    thousandsSep: ',',
  },
  plotOptions: {
    series: {
      animation: false,
      showCheckbox: true,
      selected: true,
      turboThreshold: 0,
      events: {
        checkboxClick: function() {
          if(this.visible) {
            this.hide();
          } else {
            this.show();
          }
          return false;
        },
        hide: function() {
          $(this.checkbox).prop('checked', false);
        },
        show: function() {
          $(this.checkbox).prop('checked', true);
        }
      }
    }
  },
  legend: {
    backgroundColor: 'none',
    borderColor: 'none',
    itemStyle: {"color": "#444", 'fontWeight': 'normal'},
    itemHoverStyle: {color: '#aaa'},
    itemMarginBottom: 8,
  },
  exporting: {
    enabled: true,
    buttons: {
      contextButton: {
        menuItems: [
          'printChart',
          'separator',
          'downloadPNG',
          'downloadPDF',
          'downloadSVG',
        ],
      },
    }
  }

});

// Show numbers less than 1 billion in millions.
function autoScaleBillions(amountInBillions) {
  var scale = "billion";
  var formattedAmount;

  if(amountInBillions < 1) {
    const amountInMillions = amountInBillions * 1000;
    scale = "million";
    formattedAmount = Highcharts.numberFormat(amountInMillions, 0);
  } else {
    formattedAmount = Highcharts.numberFormat(amountInBillions, 1);
  }

  return formattedAmount + " " + scale;
}

var displacementColors =["#234987"];
// Collect the data from the hidden table (for accessibility) into
// options to point.
var petroleumSavingsYears = [];
var cumulativeDisplacements = [];
$("#petroleum_savings_data tbody tr").each(function(i) {
  var row = $(this);
  // Collect years from the row header.
  petroleumSavingsYears.push($(row.children("th").get(0)).text());
  // Collect the GGE data (storing as billions of GGEs for graphing).
  var data = row.children("td");
  var option = {
    y: parseFloat($(data.get(1)).text()) / 1000000000,
    annualDisplacement: parseFloat($(data.get(0)).text()) / 1000000000,
    // FIXME: A bug in Highcharts and IE requires explicitly setting the
    // color on each series, or else IE will pick random colors. Remove if
    // Highcharts fixes issue.
    // http://highslide.com/forum/viewtopic.php?f=9&t=7407
    color: displacementColors[0]
  };
  // Special color for the most recent year.
  if(i == 0) {
  option.color = "#D8662C";
  }
  cumulativeDisplacements.push(option);
});
new Highcharts.Chart({
  chart: {
    renderTo: "petroleum_savings_chart",
    defaultSeriesType: "bar",
    marginRight: 40,
    height: 440,
    backgroundColor: null,
  },
  title: {
    text: null
  },
  xAxis: {
    tickLength: 3,
    categories: petroleumSavingsYears
  },
  yAxis: {
    // Enable tick markers.
    tickWidth: 1,
    tickLength: 3,
    // Force 0-16 range, with 1 intervals.
    min: 0,
    max: 16,
    tickInterval: 1,
    // Enable the axis line.
    lineWidth: 1,
    title: {
      text: "Billions of gasoline gallon equivalents"
    }
  },
  plotOptions: {
    bar: {
      // Make the bars wider.
      pointWidth: 10,
      // Force small bars to still take up at least 3 pixels.
      minPointLength: 3
    }
  },
  tooltip: {
    useHTML: true,
    padding: 1,
    formatter: function() {
      return "<strong>Cumulative Energy Use Impact:</strong> " + autoScaleBillions(this.y) + " gallons<br/>" +
        "<strong>Energy Use Impact in " + this.point.category + ":</strong> " + autoScaleBillions(this.point.annualDisplacement) + " gallons";
    }
  },
  legend: {
    enabled: false
  },
  colors: displacementColors,
  series: [{
    name: "Cumulative Gasoline Gallon Equivilants Displaced",
    data: cumulativeDisplacements
  }]
});

var technologyColors = ["#00A5E7", "#629248", "#B2377A", "#DC2915", "#2F2679", "#F58600", "#F9DC02"];
// Collect the data from the hidden table (for accessibility) into
// options to point.
var technologyGgeReduced = [];
var technologyGgeReducedTotal = 0;
$("#petroleum_reduction_technology_data tbody tr").each(function(i) {
  var row = $(this);
  var dataOption = {
    name: $(row.children("th").get(0)).text(),
    y: parseFloat($(row.children("td").get(0)).text()),
    // FIXME: A bug in Highcharts and IE requires explicitly setting the
    // color on each series, or else IE will pick random colors. Remove if
    // Highcharts fixes issue.
    // http://highslide.com/forum/viewtopic.php?f=9&t=7407
    color: technologyColors[i]
  };
  // A work-around to force a minimum slice size. Make each value at
  // least 7,000,000 (this may need to be adjusted if the underlying
  // data changes).
  dataOption.value = dataOption.y;
  technologyGgeReducedTotal += dataOption.y;
  if(dataOption.y < 15) {
    dataOption.y = 15;
  }
  technologyGgeReduced.push(dataOption)
});
new Highcharts.Chart({
  chart: {
    renderTo: "petroleum_reduction_technology_chart",
    defaultSeriesType: "pie",
    backgroundColor: null,
  },
  title: {
    text: null
  },
  plotOptions: {
    pie: {
      startAngle: 40,
      size: "65%",
      center: ["50%", "45%"],
      dataLabels: {
        style: {
          width: '100px',
          color: '#000000',
          textOutline: 'none',
        },
        distance: 25,
        formatter: function() {
          // Recalculate the percentage using the real value (since
          // this.y may have been forced to a higher value to
          // simulate a minimum pie slice size).
          var percentage = (this.point.value / technologyGgeReducedTotal) * 100;

          return this.point.name + ", " + Highcharts.numberFormat(percentage, 0) + "%";
        }
      }
    }
  },
  tooltip: {
    useHTML: true,
    padding: 1,
    formatter: function() {
      return "<strong>" + this.point.name + ":</strong> " + this.point.value.toFixed(1) + " million GGEs";
    }
  },
  colors: technologyColors,
  series: [{
    type: "pie",
    data: technologyGgeReduced
  }]
});

var fuelColors = ["#009FC6", "#FE4800", "#AACCE5", "#A5280A", "#6C9C76", "#FEBD00", "#B2377A", "#3d7016", "#635757", "#1473bc"];
// Collect the data from the hidden table (for accessibility) into
// options to point.
var vehicleInventoryYears = [];
$("#vehicle_inventory_data thead th").each(function(i) {
  if(i > 0) {
    vehicleInventoryYears.push($(this).text());
  }
});

var vehicleInventories = [];
$("#vehicle_inventory_data tbody tr").each(function(i) {
  var row = $(this);

  var fuelSeries = {
    name: $(row.children("th").get(0)).text(),
    data: [],

    // FIXME: A bug in Highcharts and IE requires explicitly setting the
    // color on each series, or else IE will pick random colors. Remove if
    // Highcharts fixes issue.
    // http://highslide.com/forum/viewtopic.php?f=9&t=7407
    color: fuelColors[i]
  }

  row.children("td").each(function() {
    fuelSeries.data.push(parseInt($(this).text()));
  });

  vehicleInventories.push(fuelSeries);
});

new Highcharts.Chart({
  chart: {
    renderTo: "vehicle_inventory_chart",
    defaultSeriesType: "column",
    marginRight: 204,
    backgroundColor: null,
  },
  title: {
    text: null
  },
  xAxis: {
    tickLength: 3,
    categories: vehicleInventoryYears
  },
  yAxis: {
    // Enable tick markers.
    tickWidth: 1,
    tickLength: 3,

    // Enable the axis line.
    lineWidth: 1,

    title: {
      text: "Vehicles"
    },

    labels: {
      // Show the full numbers in the axis (not the shortened "800k"
      // for thousands).
      formatter: function() {
        return Highcharts.numberFormat(this.value, 0);
      }
    }
  },
  plotOptions: {
    column: {
      borderWidth: 0,
      shadow: false,

      stacking: "normal",

      // Force small bars to still take up at least 3 pixels.
      minPointLength: 3
    }
  },
  tooltip: {
    useHTML: true,
    padding: 1,
    formatter: function() {
      return "<strong>" + this.series.name + " Vehicles in " + this.x + ":</strong> " + Highcharts.numberFormat(this.y, 0) + " vehicles (" + Highcharts.numberFormat(this.percentage, 1) + "%)<br/>" +
        "<strong>Total:</strong> " + Highcharts.numberFormat(this.point.stackTotal, 0) + " vehicles";
    }
  },
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "top",
    x: 40,
    y: 24,
    borderWidth: 0,
    width: 194
  },
  colors: fuelColors,
  series: vehicleInventories
});

// Collect the data from the hidden table (for accessibility) into
// options to point.
var stationInventoryYears = [];
$("#station_inventory_data thead th").each(function(i) {
  if(i > 0) {
    stationInventoryYears.push($(this).text());
  }
});

var stationInventories = [];
$("#station_inventory_data tbody tr").each(function(i) {
  var row = $(this);

  var fuelSeries = {
    name: $(row.children("th").get(0)).text(),
    data: [],

    // FIXME: A bug in Highcharts and IE requires explicitly setting the
    // color on each series, or else IE will pick random colors. Remove if
    // Highcharts fixes issue.
    // http://highslide.com/forum/viewtopic.php?f=9&t=7407
    color: fuelColors[i]
  }

  row.children("td").each(function() {
    fuelSeries.data.push(parseInt($(this).text()));
  });

  stationInventories.push(fuelSeries);
});

new Highcharts.Chart({
  chart: {
    renderTo: "station_inventory_chart",
    defaultSeriesType: "column",
    marginRight: 204,
    backgroundColor: null,
  },
  title: {
    text: null
  },
  xAxis: {
    tickLength: 3,
    categories: stationInventoryYears,
    labels: {
      rotation: -45,
        align: 'right'
    }
  },
  yAxis: {
    // Enable tick markers.
    tickWidth: 1,
    tickLength: 3,

    // Enable the axis line.
    lineWidth: 1,

    title: {
      text: "Stations"
    },

    labels: {
      // Show the full numbers in the axis (not the shortened "800k"
      // for thousands).
      formatter: function() {
        return Highcharts.numberFormat(this.value, 0);
      }
    }
  },
  plotOptions: {
    column: {
      borderWidth: 0,
      shadow: false,

      stacking: "normal",

      // Force small bars to still take up at least 3 pixels.
      minPointLength: 3
    }
  },
  tooltip: {
    useHTML: true,
    padding: 1,
    formatter: function() {
      return "<strong>" + this.series.name + " Stations in " + this.x + ":</strong> " + Highcharts.numberFormat(this.y, 0) + " stations (" + Highcharts.numberFormat(this.percentage, 1) + "%)<br/>" +
        "<strong>Total:</strong> " + Highcharts.numberFormat(this.point.stackTotal, 0) + " stations";
    }
  },
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "top",
    x: 40,
    y: 24,
    borderWidth: 0,
    width: 194
  },
  colors: fuelColors,
  series: stationInventories
});
